    (() => {
      if (window.__FR_ProductCardGalleryInit) return;
      window.__FR_ProductCardGalleryInit = true;

      const supportsIO = 'IntersectionObserver' in window;

      const shouldReducePrefetch = () => {
        try {
          const c = navigator.connection;
          return !!(c && (c.saveData || (c.effectiveType && /2g/.test(c.effectiveType))));
        } catch (e) { return false; }
      };

      const loadImg = (img) => {
        if (!img || img.dataset.loaded === 'true') return;
        const src = img.getAttribute('data-src');
        const srcset = img.getAttribute('data-srcset');
        const sizes = img.getAttribute('data-sizes');
        if (sizes) img.setAttribute('sizes', sizes);
        if (srcset) img.setAttribute('srcset', srcset);
        if (src) img.setAttribute('src', src);
        img.dataset.loaded = 'true';
      };

      const updateDots = (gallery) => {
        const track = gallery.querySelector('[data-gallery-track]');
        const dots = gallery.querySelectorAll('[data-dot]');
        if (!track || !dots.length) return;

        const slideW = track.clientWidth || 1;
        const idx = Math.round(track.scrollLeft / slideW);

        for (let i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === idx);
        }
      };

      const wireGallery = (gallery) => {
        if (!gallery || gallery.dataset.wired === 'true') return;
        gallery.dataset.wired = 'true';

        const slides = parseInt(gallery.getAttribute('data-slides') || '0', 10);
        if (slides <= 1) return;

        const track = gallery.querySelector('[data-gallery-track]');
        if (!track) return;

        const prefetchSecond = () => {
          if (shouldReducePrefetch()) return;
          const img = gallery.querySelector('img[data-prefetch="viewport"]');
          if (img) loadImg(img);
        };

        let interacted = false;
        const loadAllOnInteraction = () => {
          if (interacted) return;
          interacted = true;
          const imgs = gallery.querySelectorAll('img[data-src]');
          for (let i = 0; i < imgs.length; i++) loadImg(imgs[i]);
        };

        // dots on scroll (rAF)
        let raf = null;
        track.addEventListener('scroll', () => {
          if (raf) return;
          raf = requestAnimationFrame(() => {
            raf = null;
            updateDots(gallery);
          });
        }, { passive: true });

        // swipe intent + prevent accidental navigation clicks
        let isDragging = false;
        let startX = 0;
        let startY = 0;
        let moved = false;

        track.addEventListener('pointerdown', (e) => {
          isDragging = true;
          moved = false;
          startX = e.clientX;
          startY = e.clientY;
        }, { passive: true });

        track.addEventListener('pointermove', (e) => {
          if (!isDragging) return;
          const dx = Math.abs(e.clientX - startX);
          const dy = Math.abs(e.clientY - startY);
          if (dx > 6 && dx > dy) {
            moved = true;
            loadAllOnInteraction();
          }
        }, { passive: true });

        const endDrag = () => {
          isDragging = false;
          if (moved) {
            const links = gallery.querySelectorAll('[data-gallery-link]');
            for (let i = 0; i < links.length; i++) {
              links[i].dataset.blockClick = 'true';
              setTimeout(() => { delete links[i].dataset.blockClick; }, 250);
            }
          }
        };

        track.addEventListener('pointerup', endDrag, { passive: true });
        track.addEventListener('pointercancel', endDrag, { passive: true });

        gallery.addEventListener('click', (e) => {
          const a = e.target && e.target.closest ? e.target.closest('[data-gallery-link]') : null;
          if (a && a.dataset.blockClick === 'true') {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);

        updateDots(gallery);

        if (supportsIO) {
          const io = new IntersectionObserver((entries) => {
            for (let i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                prefetchSecond();
                io.unobserve(entries[i].target);
              }
            }
          }, { root: null, threshold: 0.25 });
          io.observe(gallery);
        } else {
          prefetchSecond();
        }
      };

      const init = () => {
        const galleries = document.querySelectorAll('[data-mobile-gallery]');
        for (let i = 0; i < galleries.length; i++) wireGallery(galleries[i]);
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }

      document.addEventListener('shopify:section:load', init);
    })();
